(function () {
  var settings = window.tanysiaPopupSettings;
  if (!settings || !settings.enabled) return;

  var STORAGE_KEY = 'tanysia_popup_dismissed_at';
  var TAB_POSITION_KEY = 'tanysia_popup_tab_position';

  var overlay = document.getElementById('tanysia-popup-overlay');
  var tab = document.getElementById('tanysia-popup-tab');
  var copyBtn = document.getElementById('tanysia-popup-copy-btn');
  if (!overlay) return;

  function shouldShow() {
    var dismissedAt = localStorage.getItem(STORAGE_KEY);
    if (!dismissedAt) return true;

    var daysSince = (Date.now() - parseInt(dismissedAt, 10)) / (1000 * 60 * 60 * 24);
    return daysSince >= settings.reappearAfterDays;
  }

  function openPopup() {
    overlay.classList.add('is-visible');
    overlay.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    if (tab) tab.classList.remove('is-visible');
  }

  function closePopup() {
    overlay.classList.remove('is-visible');
    overlay.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    localStorage.setItem(STORAGE_KEY, Date.now().toString());
    if (tab) tab.classList.add('is-visible');
  }

  var justSubmitted = window.location.search.indexOf('customer_posted=true') !== -1;

  if (justSubmitted) {
    openPopup();
  } else if (!shouldShow()) {
    if (tab) tab.classList.add('is-visible');
  } else {
    window.setTimeout(openPopup, settings.delaySeconds * 1000);
  }

  document.getElementById('tanysia-popup-close').addEventListener('click', closePopup);
  document.getElementById('tanysia-popup-decline').addEventListener('click', closePopup);

  overlay.addEventListener('click', function (e) {
    if (e.target === overlay) closePopup();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && overlay.classList.contains('is-visible')) closePopup();
  });

  // ===== Copy-to-clipboard on the discount code =====
  if (copyBtn) {
    copyBtn.addEventListener('click', function () {
      var code = copyBtn.getAttribute('data-code') || '';

      function showCopiedState() {
        copyBtn.classList.add('is-copied');
        window.setTimeout(function () {
          copyBtn.classList.remove('is-copied');
        }, 1500);
      }

      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(code).then(showCopiedState).catch(function () {
          fallbackCopy(code, showCopiedState);
        });
      } else {
        fallbackCopy(code, showCopiedState);
      }
    });
  }

  function fallbackCopy(text, onSuccess) {
    var textarea = document.createElement('textarea');
    textarea.value = text;
    textarea.style.position = 'fixed';
    textarea.style.opacity = '0';
    document.body.appendChild(textarea);
    textarea.focus();
    textarea.select();
    try {
      document.execCommand('copy');
      onSuccess();
    } catch (e) {
      /* silent fail — clipboard not available */
    }
    document.body.removeChild(textarea);
  }

  // ===== Draggable side tab =====
  if (tab) {
    var isDragging = false;
    var didDrag = false;
    var dragStartY = 0;
    var tabStartTop = 0;
    var tabHeight = 0;

    function applyStoredPosition() {
      var stored = localStorage.getItem(TAB_POSITION_KEY);
      tabHeight = tab.offsetHeight || 120;

      if (stored) {
        var percent = parseFloat(stored);
        if (!isNaN(percent)) {
          setTabTop(percent * window.innerHeight);
          tab.classList.add('is-positioned');
          return;
        }
      }
      // default: vertical center, handled by CSS (top:50%) — nothing to do
    }

    function clampTop(top) {
      var margin = 20;
      var max = window.innerHeight - tabHeight - margin;
      if (top < margin) return margin;
      if (top > max) return max;
      return top;
    }

    function setTabTop(top) {
      var clamped = clampTop(top);
      tab.style.top = clamped + 'px';
    }

    function getPointerY(e) {
      if (e.touches && e.touches.length) return e.touches[0].clientY;
      if (e.changedTouches && e.changedTouches.length) return e.changedTouches[0].clientY;
      return e.clientY;
    }

    function dragStart(e) {
      isDragging = true;
      didDrag = false;
      tabHeight = tab.offsetHeight || 120;
      dragStartY = getPointerY(e);

      var rect = tab.getBoundingClientRect();
      tabStartTop = rect.top;

      tab.classList.add('is-dragging');
      tab.classList.add('is-positioned');
    }

    function dragMove(e) {
      if (!isDragging) return;
      var currentY = getPointerY(e);
      var deltaY = currentY - dragStartY;

      if (Math.abs(deltaY) > 4) didDrag = true;

      setTabTop(tabStartTop + deltaY);
    }

    function dragEnd() {
      if (!isDragging) return;
      isDragging = false;
      tab.classList.remove('is-dragging');

      var rect = tab.getBoundingClientRect();
      var percent = rect.top / window.innerHeight;
      localStorage.setItem(TAB_POSITION_KEY, percent.toString());

      // If it was a genuine drag, swallow the following click so it doesn't reopen the popup unintentionally.
      if (didDrag) {
        var swallowClick = function (e) {
          e.preventDefault();
          e.stopPropagation();
          tab.removeEventListener('click', swallowClick, true);
        };
        tab.addEventListener('click', swallowClick, true);
      }
    }

    tab.addEventListener('mousedown', dragStart);
    document.addEventListener('mousemove', dragMove);
    document.addEventListener('mouseup', dragEnd);

    tab.addEventListener('touchstart', dragStart, { passive: true });
    document.addEventListener('touchmove', dragMove, { passive: true });
    document.addEventListener('touchend', dragEnd);

    tab.addEventListener('click', function (e) {
      if (didDrag) {
        e.preventDefault();
        return;
      }
      openPopup();
    });

    applyStoredPosition();

    window.addEventListener('resize', function () {
      var stored = localStorage.getItem(TAB_POSITION_KEY);
      if (stored) {
        var percent = parseFloat(stored);
        if (!isNaN(percent)) setTabTop(percent * window.innerHeight);
      }
    });
  }
})();